export const SOCIAL_NETWORK_DISPLAY_NAME: Record<string, string> = {
  instagram: 'Instagram',
  instagram_business: 'Instagram',
  tiktok: 'TikTok',
  tiktok_v2: 'TikTok',
  tiktok_creator_marketplace: 'TikTok',
  facebook: 'Facebook',
  youtube: 'YouTube',
  twitter: 'Twitter',
  pinterest: 'Pinterest',
  pinterest_organic: 'Pinterest',
};

export const NETWORK_CANONICAL_NAME: Record<string, string> = {
  instagram: 'instagram',
  instagram_business: 'instagram',
  tiktok: 'tiktok',
  tiktok_v2: 'tiktok',
  tiktok_creator_marketplace: 'tiktok',
  youtube: 'youtube',
};
